import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { slugifyParam } from 'utils/url';

export default [
  {
    path: 'product/(:productName)/:productSku',
    onEnterHandlers: [
      verifyRequiredBetaFeatures(['RAVEN_BOP']),
      (nextState, replace) => {
        const { productName, productSku } = nextState.params;
        replace(`/products/${slugifyParam(productName, productSku)}${nextState.location.search}`);
      },
    ],
  },
  {
    path: 'getProductDetails(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures(['RAVEN_BOP']),
      (nextState, replace) => {
        const productName = null; // unable to get the name from query params
        const productSku = nextState.location.query.sku;
        replace(`/products/${slugifyParam(productName, productSku)}`);
      }],
  },
];

